module.exports = __webpack_public_path__ + "img/confetti.bac0bdde.png";